export default __webpack_public_path__ + "static/svg-symbols-4260c7575c048f174f539c77541840eb.svg";